import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ViewChild,
  NgZone,
  Renderer2,
  OnDestroy,
  ElementRef,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime, filter, throttleTime } from "rxjs/operators";
import { MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";

interface GalleryItem {
  ImageURL: string;
  thumbnail: string;
  category: string;
  title: string;
}
interface GalleryClientCategory {
  el: ElementRef;
  rect: DOMRect;
}
interface RawImage {
  path: string;
  parentIndex: number;
}
@Component({
  selector: 'gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
})
export class GalleryComponent {
  private data = JSON.parse(sessionStorage.getItem("cruisegallery"));
//   private data = [
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/2b755052_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/2b755052_b.jpg",
//         "category": "Featured Image",
//         "title": "Featured Image"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/2d39e0b2_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/2d39e0b2_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0676bcd4_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0676bcd4_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ef1af128_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ef1af128_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/c42e8de9_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/c42e8de9_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/cfbd7ccb_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/cfbd7ccb_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/66f2da2f_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/66f2da2f_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/fa00de23_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/fa00de23_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/5dcfbbbf_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/5dcfbbbf_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4fa5369f_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4fa5369f_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/7038eea7_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/7038eea7_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/83aefccf_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/83aefccf_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/c5bdd4ed_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/c5bdd4ed_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/19a2fc7e_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/19a2fc7e_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/aab90934_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/aab90934_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ec9a44f5_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ec9a44f5_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/00f72663_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/00f72663_b.jpg",
//         "category": "Room",
//         "title": "Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ad2c1b4f_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ad2c1b4f_b.jpg",
//         "category": "View from Room",
//         "title": "View from Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0625383d_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0625383d_b.jpg",
//         "category": "View from Room",
//         "title": "View from Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/6dd23cb7_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/6dd23cb7_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a9e8c528_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a9e8c528_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/6616e50c_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/6616e50c_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/9c168dac_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/9c168dac_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/1f4fbdd8_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/1f4fbdd8_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/bb998b82_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/bb998b82_b.jpg",
//         "category": "Bathroom",
//         "title": "Bathroom"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/12ab1c31_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/12ab1c31_b.jpg",
//         "category": "Pool",
//         "title": "Pool"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/b32c2cfc_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/b32c2cfc_b.jpg",
//         "category": "Gym",
//         "title": "Gym"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/806bc447_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/806bc447_b.jpg",
//         "category": "Spa",
//         "title": "Spa"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/8297978d_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/8297978d_b.jpg",
//         "category": "Spa",
//         "title": "Spa"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4ff0166b_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4ff0166b_b.jpg",
//         "category": "Treatment Room",
//         "title": "Treatment Room"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/aaa483c9_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/aaa483c9_b.jpg",
//         "category": "Sports Facility",
//         "title": "Sports Facility"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/404ad7c0_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/404ad7c0_b.jpg",
//         "category": "Dining",
//         "title": "Dining"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/7d110a0e_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/7d110a0e_b.jpg",
//         "category": "Breakfast Area",
//         "title": "Breakfast Area"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/9e933fc2_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/9e933fc2_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a249dab7_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a249dab7_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/fbfab585_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/fbfab585_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/35d84be4_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/35d84be4_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/891dd11d_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/891dd11d_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0609b84f_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/0609b84f_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/12861dff_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/12861dff_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4d073be3_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4d073be3_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/296fe82a_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/296fe82a_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/30e5985e_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/30e5985e_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/76d731a6_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/76d731a6_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/08f900cb_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/08f900cb_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ce6b7c15_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/ce6b7c15_b.jpg",
//         "category": "Restaurant",
//         "title": "Restaurant"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a62266b0_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/a62266b0_b.jpg",
//         "category": "Interior",
//         "title": "Interior"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/56eb80a4_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/56eb80a4_b.jpg",
//         "category": "Meeting Facility",
//         "title": "Meeting Facility"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4d5f6e5e_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/4d5f6e5e_b.jpg",
//         "category": "Meeting Facility",
//         "title": "Meeting Facility"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/8a327735_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/8a327735_b.jpg",
//         "category": "Executive Lounge",
//         "title": "Executive Lounge"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/b773b579_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/b773b579_b.jpg",
//         "category": "Executive Lounge",
//         "title": "Executive Lounge"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/36c6628f_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/36c6628f_b.jpg",
//         "category": "Front of Property - Evening/Night",
//         "title": "Front of Property - Evening/Night"
//     },
//     {
//         "image": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/d4b63c59_b.jpg",
//         "thumbnail": "https://i.travelapi.com/hotels/1000000/580000/577900/577808/d4b63c59_b.jpg",
//         "category": "Garden",
//         "title": "Garden"
//     }
// ];
  //hotelName = "ITC Maratha Mumbai, a Luxury Collection Hotel, Mumbai";
  rating = 5;
  math = Math;

  private groupedData = {};

  categories: string[] = [];
  private categoriesClient: GalleryClientCategory[] = [];
  @ViewChildren("categoryItem") categoryDOMList: QueryList<ElementRef>;
  @ViewChild("categoryUl", { static: false }) categoryUl: ElementRef;
  @ViewChild("categoryWrapper", { static: false }) categoryWrapper: ElementRef;
  rawImages: RawImage[] = [];
  rawImageIndex = 0;
  @ViewChild("rawImagesWrapper", { static: false })
  rawImagesWrapper: ElementRef;
  @ViewChild("rawImagesUl", { static: false }) rawImagesUl: ElementRef;
  @ViewChildren("rawImageLi") rawImageList: QueryList<ElementRef>;
  @ViewChild("thumbnailWrapper", { static: false })
  thumbnailWrapper: ElementRef;
  @ViewChild("thumbnailUl", { static: false }) thumbnailUl: ElementRef;
  @ViewChildren("thumbnailLi") thumbList: QueryList<ElementRef>;
  private thumbnailsClient: GalleryClientCategory[] = [];
  // private generalHelper: GeneralHelper = new GeneralHelper();

  payloadSubscription: Subscription;
  keyboardEventSubscription: Subscription;
  public loading = false;
  // private generalAdapter: GeneralAdapter = new GeneralAdapter(
  //   this.generalState
  // );
  _eventTrackSub: Subscription;
  // private errorLogger: ErrorLogger = new ErrorLogger(
  //   this.generalState,
  //   this.generalService
  // );
  constructor(
    // private generalService: GeneralService,
    @Inject(PLATFORM_ID) private platform: any,
    // private generalState: GeneralStateService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private zone: NgZone,
    private dialogRef: MatDialogRef<GalleryComponent>,
    // private hotelState: HotelStateService
  ) {}

  closeGallery() {
    this.dialogRef.close();
  }

  nextThumb() {
    const windowWidth = this.getWindowWidth();
    const left = this.thumbnailWrapper.nativeElement.scrollLeft;
    this.scrollThumbWrapper(left + windowWidth / 2);
  }

  private scrollThumbWrapper(unit) {
    this.smoothScroll(this.thumbnailWrapper.nativeElement, unit);
  }

  prevThumb() {
    const windowWidth = this.getWindowWidth();
    const left = this.thumbnailWrapper.nativeElement.scrollLeft;
    if (left > 0) {
      this.scrollThumbWrapper(left - windowWidth / 2);
    }
  }

  thumbnailTapped(i) {
    this.rawImageIndex = i;
    this.animateRawSlide();
    this.toggleThumbnailActiveClass(i);
    const windowWidth = this.getWindowWidth();
    const rect = this.thumbnailsClient[i].rect;
    this.smoothScroll(
      this.thumbnailWrapper.nativeElement,
      rect.x - windowWidth / 2
    );
    this.tabChangeSyncOnRawImageChange(this.rawImageIndex);
  }

  private tabChangeSyncOnRawImageChange(i) {
    const tabSyncIndex = this.rawImages[i].parentIndex - 1;
    this.toggleCategoriesActiveClass(tabSyncIndex);
    this.scrollOnTap(tabSyncIndex);
  }

  private toggleThumbnailActiveClass(i: number) {
    this.thumbnailsClient.forEach((x) => {
      x.el.nativeElement.classList.remove("active");
    });
    this.thumbnailsClient[i].el.nativeElement.classList.add("active");
  }

  // public getCDNPath() {
  //   return (
  //     this.generalHelper.getCDNPath() + "/assets/img/hotel/no-image-found.jpg"
  //   );
  // }

  prevSlide() {
    if (this.rawImageIndex > 0) {
      this.rawImageIndex--;
      this.onSlideChange();
    }
  }

  nextSlide() {
    if (this.rawImages.length - 1 > this.rawImageIndex) {
      // length - 1 because index zero based
      this.rawImageIndex++;
      this.onSlideChange();
    }
  }

  private onSlideChange() {
    this.animateRawSlide();
    this.toggleThumbnailActiveClass(this.rawImageIndex);
    const windowWidth = this.getWindowWidth();
    const rect = this.thumbnailsClient[this.rawImageIndex].rect;
    this.smoothScroll(
      this.thumbnailWrapper.nativeElement,
      rect.x - windowWidth / 2
    );

    this.tabChangeSyncOnRawImageChange(this.rawImageIndex);
  }

  private animateRawSlide() {
    const constWidth = this.getWindowWidth();
    const left = constWidth * this.rawImageIndex;
    this.rawImagesUl.nativeElement.style.marginLeft = `-${left}px`;
  }

  prevCategory() {
    const windowWidth = this.getWindowWidth();
    const left = this.categoryWrapper.nativeElement.scrollLeft;
    this.smoothScroll(
      this.categoryWrapper.nativeElement,
      left - windowWidth / 2
    );
  }

  nextCategory() {
    const windowWidth = this.getWindowWidth();
    const left = this.categoryWrapper.nativeElement.scrollLeft;
    this.smoothScroll(
      this.categoryWrapper.nativeElement,
      left + windowWidth / 2
    );
  }

  private smoothScroll(el, unit) {
    el.scroll({
      top: 0,
      left: unit,
      behavior: "smooth",
    });
  }

  categoryTapped(i: number, categoryUName = "") {
    this.scrollOnTap(i);

    let syncThumbIndex = 0;
    for (let j = 0; j <= i; j++) {
      const list = this.groupedData[`${this.categories[j]}`];
      syncThumbIndex += list.length;
    }
    // sync number - current category image length
    const currentCategoryImages = this.groupedData[`${categoryUName}`];
    this.rawImageIndex = syncThumbIndex - currentCategoryImages.length;
    // after sync animate raw slider
    this.animateRawSlide();
    // after sync animate thumbnail slider
    // raw image index is also applicable for thumbnail list

    const thumbClient = this.thumbnailsClient[this.rawImageIndex];
    const windowWidth = this.getWindowWidth();
    this.scrollThumbWrapper(thumbClient.rect.left - windowWidth / 2);
    this.toggleThumbnailActiveClass(this.rawImageIndex);
  }

  private scrollOnTap(i: number) {
    const windowWidth = this.getWindowWidth();
    const rect = this.categoriesClient[i].rect;
    this.toggleCategoriesActiveClass(i);
    this.smoothScroll(
      this.categoryWrapper.nativeElement,
      rect.x - windowWidth / 2
    );
  }

  private toggleCategoriesActiveClass(i: number) {
    this.categoriesClient.forEach((x) => {
      x.el.nativeElement.classList.remove("active");
    });
    this.categoriesClient[i].el.nativeElement.classList.add("active");
  }
  
  ngOnInit() {
    // if (isPlatformBrowser(this.platform)) {
    // }
    // this.payloadSubscription = this.hotelState.galleryPayloadLoaded$.subscribe(
      // () => {
        // this.hotelName = this.hotelState.galleryPayload["hotelName"];
        // this.rating = this.hotelState.galleryPayload["startRating"];
        this.prepareData(this.data);

        // todo
        // if (this.hotelState.galleryPayload["activeCategory"]) {
        //   setTimeout(() => {
        //     this.loading = false;
        //   }, 2000);
        // } else {
        //   this.loading = false;
        // }
      // }
    // );
    if (isPlatformBrowser(this.platform)) {
      this.renderer.addClass(document.body, "gallery-opened");
      this.keyboardEventSubscription = fromEvent<KeyboardEvent>(
        document,
        "keydown"
      )
        .pipe(
          throttleTime(300),
          filter((x) => x.keyCode == 39 || x.keyCode == 37)
        )
        .subscribe((x) => {
          if (x.keyCode == 37) {
            this.prevSlide();
          } else {
            this.nextSlide();
          }
        });
    }
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platform)) {
      this.renderer.removeClass(document.body, "gallery-opened");
    }
    if (this.payloadSubscription) {
      this.payloadSubscription.unsubscribe();
    }
    if (this.keyboardEventSubscription) {
      this.keyboardEventSubscription.unsubscribe();
    }
  }
  ngAfterViewInit() {
    // if (isPlatformBrowser(this.platform)) {
    //   this.errorLogger.Log(
    //     "B2CPORTAL",
    //     "INFORMATION",
    //     "HTL",
    //     "GalleryComponent",
    //     "gallery component loaded"
    //   );
    // }
    // resize reset
    this.zone.runOutsideAngular(() => {
      fromEvent(window, "resize")
        .pipe(debounceTime(300))
        .subscribe(() => {
          this.restartSlider();
        });
    });
    // this.payloadSubscription = this.hotelState.galleryPayloadLoaded$.subscribe(
    //   () => {
        setTimeout(() => {
          this.prepareView();
        }, 50);
      // }
    // );
  }

  private prepareView() {
    if (this.thumbList == null || this.thumbList.toArray().length == 0) {
      this.loading = false;
      this.closeGallery();
      return;
    }

    this.prepareCategoryDOM();
    this.prepareThumbDOM();
    this.prepareRawDOM();
  }

  private prepareRawDOM() {
    const width = this.getWindowWidth();
    this.rawImagesUl.nativeElement.style.width = `${
      width * this.rawImages.length
    }px`;
    this.rawImageList.forEach((i) => {
      i.nativeElement.style.width = `${width}px`;
    });
  }

  private prepareThumbDOM() {
    this.thumbList.forEach((x) => {
      this.thumbnailsClient.push({
        el: x,
        rect: x.nativeElement.getBoundingClientRect(),
      });
    });
  }

  private prepareCategoryDOM() {
    this.categoryDOMList.forEach((i) => {
      this.categoriesClient.push({
        el: i,
        rect: i.nativeElement.getBoundingClientRect(),
      });
    });
  }

  private getWindowWidth(): number {
    return window.innerWidth;
  }

  private restartSlider() {
    this.prepareView();
    // reset margins
    this.rawImageIndex = 0;
    this.animateRawSlide();
    this.scrollThumbWrapper(0);
    this.smoothScroll(this.categoryWrapper.nativeElement, 0);
    this.toggleCategoriesActiveClass(0);
    this.toggleThumbnailActiveClass(0);
  }

  private getKeys(obj): string[] {
    return Object.keys(obj);
  }

  private prepareData(raw: GalleryItem[]) {
    let parentIndex = 0;
    raw.forEach((i, index) => {
      const item = i as GalleryItem;
      if (!this.getKeys(this.groupedData).includes(i.category)) {
        this.groupedData[item.category] = [];
        this.categories.push(item.category);
        parentIndex++;
      }
      (this.groupedData[(i as GalleryItem).category] as GalleryItem[]).push(i);
      this.rawImages.push({
        path: item.ImageURL,
        parentIndex,
      });
    });

    // if (this.hotelState.galleryPayload["activeCategory"]) {
    //   const i = this.categories.findIndex(
    //     (x) => x == this.hotelState.galleryPayload["activeCategory"]
    //   );
    //   setTimeout(() => {
    //     this.categoryDOMList.toArray()[i].nativeElement.click();
    //   }, 1000);
    // }
    // if (
    //   this.hotelState.galleryPayload["activeCategory"] &&
    //   this.hotelState.galleryPayload["activeImageUrl"]
    // ) {
    //   const i = this.rawImages.findIndex(
    //     (x) => x.path == this.hotelState.galleryPayload["activeImageUrl"]
    //   );
    //   setTimeout(() => {
    //     this.thumbList.toArray()[i].nativeElement.click();
    //   }, 1000);
    // }
  }
}
